import { INBOX_PERMISSIONS } from 'dashboard/constants/permissions.js';
import WhatsappFlowsPage from './Index.vue';

// Flows ficam em página própria de "Campanhas e dados". A gestão segue a
// mesma política da API: administradores ou perfis com inbox_manage.
export const routes = [
  {
    path: 'campanhas/whatsapp-flows',
    name: 'whatsapp_flows',
    meta: { permissions: ['administrator', INBOX_PERMISSIONS] },
    component: WhatsappFlowsPage,
  },
];
